const options = 'light';
export default options;
